export default __webpack_public_path__ + "static/media/ReviewBad.2b381130.svg";